import * as yup from "yup";

export const phoneNumberSchema = yup
  .string()
  .required("Phone number is required")
  .matches(/\(\d{3}\) \d{3}-\d{4}/, "Invalid phone number");
